var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pencil_4_",
    "data-name": "pencil (4)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.567,
    height: 36.529,
    viewBox: "0 0 36.567 36.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4885",
    "data-name": "Path 4885",
    d: "M22.582,82.473,2.462,102.594a.8.8,0,0,0-.209.367l-2.23,8.951a.792.792,0,0,0,.768.984.787.787,0,0,0,.192-.024l8.951-2.23a.791.791,0,0,0,.367-.209l20.121-20.12Zm0,0",
    transform: "translate(0 -76.368)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4886",
    "data-name": "Path 4886",
    d: "M344.912,3.608l-2.24-2.24a4.056,4.056,0,0,0-5.6,0l-2.743,2.743,7.84,7.84,2.743-2.743a3.961,3.961,0,0,0,0-5.6Zm0,0",
    transform: "translate(-309.505 -0.246)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencilIcon.b54f7b1772131c4f78873bb9c16a99ca.svg";
export { ForwardRef as ReactComponent };